import { observable, action } from 'mobx';
import ApiCaller from '../../utils/api-caller';

class SingleListStore {
  @observable menu = null;
  @observable items = [];

  @observable item = null;
  @observable remark = '';
  @observable timeSelected = 'now';
  @observable timeDeliver = '';
  @observable timeDeliverDate = '';

  // Initialization

  @action getData(menuId, languageId) {
    this.menu = null;
    this.items = [];

    return ApiCaller.CmsTasks.getSingleList(menuId, languageId).then(resp => {
      if (!resp.isError) {
        if (resp.data) {
          this.menu = resp.data.menu;
          this.items = resp.data.items;

          this.items.map(item => {
            item.isSelected = false;
            return item;
          });
        }
      }
    });
  }

  @action getItem(itemID) {
    this.item = this.items.find(x => x.taskId === itemID);
  }

  @action setisSelected(taskId, isSelected) {
    this.items.map(item => {
      return item.isSelected = false;
    });

    const item = this.items.find(x => x.taskId === taskId);
    item.isSelected = isSelected;
  }

  @action resetData() {
    this.menu = null;
    this.item = null;
    this.items = [];
    this.remark = '';
    this.timeSelected = 'now';
    this.timeDeliver = '';
  }

  @action setremark(value) {
    this.remark = value;
  }

  @action settimeSelected(value) {
    this.timeSelected = value;
    this.timeDeliver = '';
  }

  @action settimeDeliver(value) {
    this.timeDeliver = value;
    this.timeSelected = '';
  }

  @action settimeDeliverDate(value) {
    this.timeDeliverDate = value;
  }
}

export default new SingleListStore();